module.exports = __webpack_public_path__ + "static/media/introduce_p8@2x.3a44c647.png";